import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparison } from '../data/content';
import { Reveal } from './Reveal';
export function Comparison() {
  return <section className="border-t border-paper-line bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="antes-despues" data-id="element-43" data-mp="1l7e2v9nirlku">
      <div className="mx-auto max-w-5xl" data-id="element-44" data-mp="1pz5vdpq8k1dm">
        <Reveal data-id="element-45" data-mp="1q078s0uq4zyi">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-46" data-mp="1ux7ci543pqmg">
            Antes y después
          </p>
          <h2 id="antes-despues" className="display mt-4 max-w-3xl text-4xl text-ink sm:text-5xl" data-id="element-47" data-mp="1zvil6cintv33">
            Dejá de improvisar. Empezá a entrenar con sistema.
          </h2>
        </Reveal>

        <Reveal delay={0.05} data-id="element-48" data-mp="28wgkihi5lefc">
          <div className="mt-12 overflow-hidden rounded-xl border border-paper-line" data-id="element-49" data-mp="9jvwzogml1j7">
            <div className="grid grid-cols-2" data-id="element-50" data-mp="9lyu0sg73uxf">
              <p className="bg-paper-soft px-5 py-4 text-[11px] font-extrabold uppercase tracking-[0.2em] text-ink-dim sm:px-8" data-id="element-51" data-mp="ei5vo91k6k9k">
                Sin el megapack
              </p>
              <p className="bg-ink px-5 py-4 text-[11px] font-extrabold uppercase tracking-[0.2em] text-grass sm:px-8" data-id="element-52" data-mp="1ha8vki1ubdof">
                Con el megapack
              </p>
            </div>
            {comparison.map(row => <div key={row.without} className="grid grid-cols-2 border-t border-paper-line" data-id="element-53" data-mp="18adho5gwh4kp">
                <p className="flex items-start gap-3 px-5 py-5 text-[15px] leading-relaxed text-ink-dim sm:px-8" data-id="element-54" data-mp="24x8pxdmphrhw">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-55" data-mp="1vywpkjw1ffc9" />
                  {row.without}
                </p>
                <p className="flex items-start gap-3 border-l border-paper-line bg-paper-soft px-5 py-5 text-[15px] font-medium leading-relaxed text-ink sm:px-8" data-id="element-56" data-mp="1qyqu0smnd8ow">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grass" aria-hidden="true" data-id="element-57" data-mp="fkn3jwf9q2ol" />
                  {row.with}
                </p>
              </div>)}
          </div>
        </Reveal>
      </div>
    </section>;
}